<template>
    <tr class="table-row">
        <slot />
    </tr>
</template>

<style lang="scss">
@use "@style/variables" as *;

.table-row {
    //    We give a background color to the td element instead of tr to account for sticky columns.
    td {
        background: $white;
    }

    &:nth-child(2n) {
        td {
            background: $grey0;
        }
    }
}
</style>
